export default "__VITE_ASSET__CMYUmX7N__"